<div *ngIf="loading" class="h-11 w-36 flex justify-center items-center">
    <app-loading-indicator [size]="16"></app-loading-indicator>
</div>

<button *ngIf="!loading && canExportCommitteeDetails" (click)="export($event)" class="btn btn-primary" id="btn-export-committee-details">
    <fa-icon [icon]="faDownload"></fa-icon>Export Committee Details
</button>